import React, { useState, useRef } from 'react';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftCircle } from 'react-bootstrap-icons';
import ELayout from './ELayout';
import AxiosInstance from '../AxiosInstance';
import ToastNotification from '../ToastNotification';

const WFHRequest = () => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [reason, setReason] = useState('');
  const toastRef = useRef();
  const navigate = useNavigate();
  const employeeId = Number(localStorage.getItem('employeeId'));

  const handleSubmit = () => {
    if (!startDate || !endDate || !reason) {
      toastRef.current.showToast('Please fill out all fields.', 'warning');
      return;
    }

    if (!employeeId) {
      toastRef.current.showToast('Employee ID not found. Please log in again.', 'danger');
      return;
    }

    const requestData = {
      employee_id: employeeId,
      start_date: startDate,
      end_date: endDate,
      reason
    };

    AxiosInstance.post('/employee/wfh/submit', requestData)
      .then((response) => {
        toastRef.current.showToast(response.data.message || 'WFH request submitted successfully.', 'success');
      })
      .catch(() => {
        toastRef.current.showToast('Error submitting WFH request.', 'danger');
      });
  };

  return (
    <ELayout heading={
      <div className="mb-3 d-flex align-items-center">
        <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
          <ArrowLeftCircle />
        </Button>
        <span className="ms-3">Work From Home Request</span>
      </div>
    }>
      <Form>
        <Form.Group>
          <Form.Label>Start Date</Form.Label>
          <Form.Control type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </Form.Group>
        <Form.Group>
          <Form.Label>End Date</Form.Label>
          <Form.Control type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Reason</Form.Label>
          <Form.Control as="textarea" rows={3} value={reason} onChange={(e) => setReason(e.target.value)} />
        </Form.Group>
        <div className="mt-3">
          <Button className="btn btn-secondary" onClick={handleSubmit}>Submit</Button>
        </div>
      </Form>
      <ToastNotification ref={toastRef} />
    </ELayout>
  );
};

export default WFHRequest;
